"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var H1_1 = __importDefault(require("./styledComponents/H1"));

var H2_1 = __importDefault(require("./styledComponents/H2"));

var H3_1 = __importDefault(require("./styledComponents/H3"));

var H4_1 = __importDefault(require("./styledComponents/H4"));

var H5_1 = __importDefault(require("./styledComponents/H5"));

var H6_1 = __importDefault(require("./styledComponents/H6"));

var SubTitle_1 = __importDefault(require("./styledComponents/SubTitle"));

var Heading_meta_1 = require("./Heading.meta");

var Translate_1 = __importDefault(require("../Translate"));

var Heading =
/** @class */
function (_super) {
  __extends(Heading, _super);

  function Heading(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = Heading_meta_1.HEADING_CATEGORY_KEY;
    _this.componentKey = Heading_meta_1.HEADING_COMPONENT_KEY;
    return _this;
  }

  Heading.prototype.renderTitle = function () {
    var _a = this.props,
        title = _a.title,
        level = _a.level;
    var HeadingTag;

    switch (level) {
      case 6:
        HeadingTag = H6_1.default;
        break;

      case 5:
        HeadingTag = H5_1.default;
        break;

      case 4:
        HeadingTag = H4_1.default;
        break;

      case 3:
        HeadingTag = H3_1.default;
        break;

      case 2:
        HeadingTag = H2_1.default;
        break;

      case 1:
      default:
        HeadingTag = H1_1.default;
        break;
    }

    return react_1.default.createElement(HeadingTag, null, react_1.default.createElement(Translate_1.default, null, title));
  };

  Heading.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        title = _a.title,
        subTitle = _a.subTitle;

    if (title || subTitle) {
      return react_1.default.createElement(Wrapper_1.default, {
        className: className
      }, title && this.renderTitle(), subTitle && react_1.default.createElement(SubTitle_1.default, null, react_1.default.createElement(Translate_1.default, null, subTitle)));
    }

    return null;
  };

  Heading.defaultProps = {
    title: undefined,
    subTitle: undefined,
    level: 1
  };
  Heading = __decorate([mobx_react_1.observer], Heading);
  return Heading;
}(shared_1.ComponentBase);

exports.Heading = Heading;
exports.default = shared_1.InjectedStyledComponent(Heading, Heading_meta_1.HEADING_CATEGORY_KEY, Heading_meta_1.HEADING_COMPONENT_KEY);